import styled from "styled-components";

import { DIGIPOSTHEME } from "theme/digiPosTheme";
import { BREAKPOINTS } from "context/media/MediaConstant";

export const StyledOuterContainer = styled.footer`
  display: flex;

  align-items: center;
  justify-content: space-around;

  width: 100%;

  padding: 14px 5% 11px;

  background-color: ${DIGIPOSTHEME.colors.footerGrey};

  @media (max-width: ${BREAKPOINTS.MOBILE}px) {
  }
`;

export const StyledTextWrapper = styled.div`
  height: 35px;

  display: flex;
  align-items: flex-start;
  flex-direction: column;

  padding-top: 20px;

  @media (max-width: ${BREAKPOINTS.MOBILE}px) {
    padding: 0px 5%;
  }
`;

export const StyledText = styled.div`
  color: #6f6f6f;
  font: 10px Arial, Helvetica, sans-serif;
`;
